module.exports = __webpack_public_path__ + "img/preview.12d8e3ba.webp";